{
    "title": "Reset Password",
    "subtitle": "Enter your registered email address to start the reset password process.",
    "placeholder": "E-mail Address",
    "code": "Validation Code",
    "password": "New Password",
    "passwordconfirm": "Confirm New Password",
    "passwordmatch": "Passwords do not match. Please try again.",
    "codesent": "The validation code has been sent to your email address. Please check your inbox and spam folder.",
    "passwordrecovered": "Password has been successfully reset. Please login with your new password."
}